// import defineRule from '../defineRule'

import { defineRule } from "vee-validate"

defineRule('passwordMatch', (value: string, [ target ]: [string]) => {
  return value === target || 'This field must match your new password'
})
